import React from 'react';
import {AuthenticationPage} from 'pages/authentication/index';

export const publicRouter = [
  {path: 'login', component: <AuthenticationPage />},
];
